import { Directive, ElementRef, ViewChild, output, input } from '@angular/core';

export const TextInputFormControlDirectiveInputs = ['type'];
export const TextInputFormControlDirectiveOutputs = ['handleBlur'];

@Directive({
  selector: '[uiTextInputFormControl]',
  standalone: true,
})
export class TextInputFormControlDirective {
  readonly type = input<'text' | 'password' | 'date' | 'number' | 'email'>('text');

  readonly handleBlur = output<void>();

  @ViewChild('nativeInputElement')
  _nativeInputElement: ElementRef | null = null;
}
